<template>
    <div class="facturas">            
        <div class="row p-1">
            <!-- Facturas Emitidas -->        
            <div class=col-sm-5>
                 <b-table striped hover bordered small
                    id="frasE"
                    sticky-header="400px" head-variant="light"
                    :items="FE" :fields="fieldsE"
                    :per-page="perPage"
                    :current-page="currentPage"                    
                    class="table-responsive-md bg-white" responsive="sm">

                    <template #cell(icono)="{ item }">
                        <p class="h4 mb-1">                            
                            <b-icon icon="file-richtext" size="sm" 
                                v-show="item.documento>'0'"
                                button @click="documento(item)" 
                                :disabled="item.documento>'0'">
                            </b-icon>
                        </p>                
                    </template> 

                </b-table>
            </div>
            <!-- Facturas Recibidas -->
            <div class=col-sm-7>
                 <b-table striped hover bordered small
                    id="frasR"
                    sticky-header="400px" head-variant="light"
                    :items="FR" :fields="fieldsR"
                    :per-page="perPage"
                    :current-page="currentPage"                    
                    class="table-responsive-md bg-white" responsive="sm">

                    <template #cell(icono)="{ item }">
                        <p class="h4 mb-1">                            
                            <b-icon icon="file-richtext" size="sm" 
                                v-show="item.documento>'0'"
                                button @click="documento(item)" 
                                :disabled="item.documento>'0'">
                            </b-icon>
                        </p>                     
                    </template>
                   
                </b-table>
            </div>
        </div>
        
        <!-- <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="tablaReservas"
        ></b-pagination> -->
    </div>
</template>

<script>

    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'facturas',
        props: {
            //padre: { type:String, default: '' },                                     
            FE: { type:Array, default: ()=> [] },
            FR: { type:Array, default: ()=> [] },
             
        },
        components: {            
        },
        data() {
            return {

                fieldsE: [
                    //{ key: 'action', label:'' },    
                    { key: 'icono', label:'' },                
                    { key: 'fra', label: 'Factura', sortable: true },                
                    { key: 'fhF', label: 'Fecha', sortable: true },
                    { key: 'base', label: 'Importe', sortable: true },                                        
                    
                    
                ],     
                fieldsR: [
                    //{ key: 'action', label:'' },    
                    { key: 'icono', label:'' },                
                    { key: 'prov', label: 'Proveedor', sortable: true },                
                    { key: 'fra', label: 'Factura', sortable: true },
                    { key: 'fhf', label: 'Fecha', sortable: true },                                        
                    { key: 'imp', label: 'Importe', sortable: true },                                        

                ],              

                itemsStd:[
                    {value:'0', text:'(Estado)'},
                    {value:'1', text:'ACTIVO'},
                    {value:'2', text:'FINALIZADO'},
                    {value:'3', text:'ANULADO'},
                ],            

                perPage: 0,
                currentPage: 1,

                
            }
        },
        computed: {
            ...mapState(['auth']),                                  
            
            // cbStd() {
            //     return this.itemsStd;
            // }

        },
        mounted() {            

            //this.leemos();

        },
        methods: {
            ...mapMutations(['loading','alerta','modal']),
            ...mapActions(['exec']),

            
            //iconoStd(std) {                
                //return this.estados[std];
            //}
            
            async documento(item) {            
                console.log('*documento',item);
                if (item.documento=='0') return;
                //this.loading();                
                let r=await this.exec({api:'documento', 
                    arg: { token: this.auth.token, id: item.documento }
                });
                //console.log('documento',r);
                if (r.error) { 
                    this.modal({tit:"DOCUMENTO", msg:r.datos});                  
                    return;
                }                     
                // abro documento
                window.open(this.$store.state.G.url_tmp + r.datos[0], "_blank");                                    
                //this.loading(false);
            }
        },
    }
</script>